
import React, { useEffect } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useModal, EntityType } from '@/contexts/ModalContext';
import ProductDetailsView from './details/ProductDetailsView';
import OfferPageDetailsView from './details/OfferPageDetailsView';
import SubscriptionDetailsView from './details/SubscriptionDetailsView';
import TransactionDetailsView from './details/TransactionDetailsView';

const EntityDetailsModal: React.FC = () => {
  const { modalState, closeModal } = useModal();
  const { isOpen, entityType, entityId, entityData } = modalState;

  // Close on escape key
  useEffect(() => {
    const handleEscKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [isOpen, closeModal]);

  // Render the appropriate view based on entity type
  const renderEntityView = () => {
    if (!entityId) return <EntityNotFound />;

    switch (entityType) {
      case 'product':
        return <ProductDetailsView id={entityId} onClose={closeModal} />;
      case 'offer':
      case 'bundle':
        return <OfferPageDetailsView id={entityId} onClose={closeModal} />;
      case 'subscription':
        return <SubscriptionDetailsView id={entityId} data={entityData} onClose={closeModal} />;
      case 'transaction':
        return <TransactionDetailsView id={entityId} onClose={closeModal} />;
      default:
        return <EntityNotFound />;
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && closeModal()}>
<DialogContent className="w-[95%] sm:w-[80%] md:w-[60%] lg:w-[40%] xl:w-[25%] p-0 overflow-hidden rounded-none shadow-lg">
{renderEntityView()}
      </DialogContent>
    </Dialog>
  );
};

// Fallback for entity not found
const EntityNotFound: React.FC = () => (
  <div className="p-6 text-center">
    <h3 className="text-lg font-medium mb-2">Entity Not Found</h3>
    <p className="text-muted-foreground">
      The requested item could not be found or has been deleted.
    </p>
  </div>
);

export default EntityDetailsModal;
